import { getCookie } from '../../common/js/common';
import { VIEWPORT_WIDTHS } from '../../../../components/global/constants';

window.addEventListener('load', event => {
    const mobileAppDownloadModal = document.querySelector('.mobileAppDownloadModal');
    const storedMobileAppModal = sessionStorage.getItem('hideappmodal');
    const mobileAppModal = document?.querySelector('.mobile-app-modal');
    const mobileAppModalClose = document?.querySelector('.mobile-app-modal__close');
    const mobileAppModalAction = document?.querySelector('.mobile-app-modal___action');
    const headerWrap = document.querySelector('header');
    const checkSearchPage = window.location.pathname.includes('search');
    const getAuthorityType = getCookie('authority_type');

    if (mobileAppDownloadModal && mobileAppDownloadModal?.childElementCount !== 0 ) {
        const appModalDefaultValues = {
            appurl: 'sbrapp://com.sunbeltrentals.mobileapp',
            googlestoreurl: 'https://play.google.com/store/apps/details?id=com.sunbeltrentals.mobileapp&hl=en_IN&gl=US',
            applestoreurl: 'https://apps.apple.com/us/app/sunbelt-rentals/id1553310095',
            timeoutconfig: 100,
            disableappmodaldesktop: false
        };
        const {
            appurl = appModalDefaultValues.appurl,
            googlestoreurl = appModalDefaultValues.googlestoreurl,
            applestoreurl = appModalDefaultValues.applestoreurl,
            timeoutconfig = appModalDefaultValues.timeoutconfig,
            disableappmodaldesktop = appModalDefaultValues.disableappmodaldesktop
        } = mobileAppModal?.dataset || {};
        const isDesktopDisabledView = disableappmodaldesktop === 'true' && window.innerWidth > VIEWPORT_WIDTHS.DESKTOP
        if (isDesktopDisabledView) {
            mobileAppModal.classList.add('mobile-app-modal--desktop-hide');
            mobileAppDownloadModal.classList.add('mobileAppDownloadModal--desktop-hide');
        }
        const checkUserAgent = () => {
            const userAgent = navigator.userAgent || window.opera;
            let storelink = '';

            if (/Android/i.test(userAgent) || /Windows/i.test(userAgent)) {
                // Android & Windows → Play Store
                storelink = googlestoreurl;
            } else {
                storelink = applestoreurl;
            }

            window.open(storelink, '_blank');
        };

        const handleModalClick = () => {
            sessionStorage.setItem('hideappmodal', true);
            mobileAppModalClose?.closest('.mobileAppDownloadModal')?.classList.toggle('mobileAppDownloadModal--show');
            headerWrap?.parentElement && (headerWrap.parentElement.style.paddingTop = `0`);
            headerWrap?.classList?.toggle('header--app-modal');
        };

        if (mobileAppModalClose) {
            mobileAppModalClose.addEventListener('click', handleModalClick);
        }

        if (mobileAppModalAction) {
            mobileAppModalAction.addEventListener('click', () => {
                handleModalClick();
                checkUserAgent();
            });
        }

        if (!storedMobileAppModal) {
            mobileAppDownloadModal.classList.toggle('mobileAppDownloadModal--show');
            if (checkSearchPage) {
                if(!isDesktopDisabledView){
                    headerWrap.classList.toggle('header--app-modal');
                }
                headerWrap.parentElement.style.paddingTop = `${mobileAppModal.clientHeight}px`;
            }
        }
      
        if (getAuthorityType === 'p2p' || getAuthorityType === 'punchout') {
            mobileAppModalClose?.closest('.mobileAppDownloadModal')?.classList.toggle('mobileAppDownloadModal--show');
            headerWrap.parentElement.style.paddingTop = `0`;
            if(!isDesktopDisabledView){
                headerWrap?.classList?.toggle('header--app-modal');
            }
        }
    }
});
